import React from 'react';
import { BaseConfig } from '../BaseConfig';
import FailAlert from '../helpers/FailAlert';
import { UIProperties } from '../UIProperties';

import './FailUI.css'

const FailUI = (props: UIProperties<FailUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container dialogueui-container modal-disable-select">
			<div>
				<FailAlert id="directions-ui-alert" dispatch={props.dispatch} parameters={{
					title: 'Remediation',
					img: props.parameters.img,
					text: props.parameters.text,
					smallerTitle: props.parameters.smallerTitle,
					onContinueClicked: props.parameters.onContinueClicked
				}}></FailAlert>
			</div>
		</div>
	);

};

export interface FailUIConfig extends BaseConfig {
	text: string;
	img: string;
	smallerTitle?: boolean;
	onContinueClicked: () => void;
}

export default FailUI;